module.exports = __webpack_public_path__ + "img/tecnicos_ingenieros.9013f7a5.jpg";